import { render, staticRenderFns } from "./surface_post_being_edited.vue?vue&type=template&id=79734701&scoped=true&"
import script from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
export * from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_being_edited.vue?vue&type=style&index=0&id=79734701&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79734701",
  null
  
)

export default component.exports